import { useSelected } from 'slate-react';

import { cn } from '@/shadcn/lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/shadcn/tooltip';

import type { ElementProps } from '@/components/ui/richEditor/elements/elements.richEditor.types';

type Props = ElementProps;

export const LinkElement = ({
  attributes,
  children,
  element,
  readOnly
}: Props) => {
  const selected = useSelected();
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <a
            {...attributes}
            className={cn(
              'text-primary-deep',
              !readOnly && selected && '-m-0.5 bg-accent p-0.5'
            )}
            href={element.url}
          >
            <InlineChromiumBugfix />
            {children}
            <InlineChromiumBugfix />
          </a>
        </TooltipTrigger>
        <TooltipContent>
          Links to: <span className="font-semibold">{element.url}</span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

// Put this at the start and end of an inline component to work around this Chromium bug:
// https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
const InlineChromiumBugfix = () => (
  <span contentEditable={false} style={{ fontSize: 0 }}>
    ${String.fromCodePoint(160) /* Non-breaking space */}
  </span>
);
